import * as Styled from './AnalyticsHeader.styles';
import { Typography } from '@mui/material';


const AnalyticsHeader = () => {
  return (
    <>
      <Styled.AnalyticsHeaderContainer>
        <Typography variant="h1" sx={{ paddingY: '25px' }}>
          Admin Dashboard
        </Typography>
      </Styled.AnalyticsHeaderContainer>
    </>
  );
};

export default AnalyticsHeader;
